import { useTranslation } from "react-i18next";
import AppText from "../../components/Core/AppText/AppText";
import Button from "../../components/Core/Button/Button";
import Modal from "../../components/Core/Modal/Modal";
import Flex from "../../components/Layout/Flex";
import { useDeleteCollectiveAgreement } from "../../networking/collective-agreement.hooks";
import { toast } from "../../utils/toast";

interface Props {
	agreementId: string;
	onCancel: () => void;
	onSubmit: () => void;
}

export const CollectiveAgreementRemoveConfirmModal: React.FC<Props> = ({
	agreementId,
	onCancel,
	onSubmit,
}) => {
	const { t } = useTranslation();

	const { mutate: deleteAgreement, isLoading: isDeletingAgreement } =
		useDeleteCollectiveAgreement();

	async function onRemoveAgreement() {
		deleteAgreement(
			{ agreementId },
			{
				onSuccess: () => {
					toast.successGeneric();
					onSubmit();
				},
				onError: () => {
					toast.error("Kunde inte ta bort kollektivavtalet");
				},
			}
		);
	}

	return (
		<Modal>
			<Flex gap="1.5rem" direction="column" minHeight="200px">
				<AppText size="xm" weight="bold">
					Är du säker på att du vill ta bort kollektivavtalet?
				</AppText>
				<AppText size="m">
					Genom att ta bort kollektivavtalet kommer det inte längre kunna användas för konsulter.
				</AppText>
				<Flex gap="1rem" justifyContent="flex-end" margin="4rem 0 0 0">
					<Button backgroundColor="white" textColor="grayTextDark" onClick={onCancel}>
						{t("CANCEL")}
					</Button>
					<Button
						backgroundColor="danger"
						onClick={onRemoveAgreement}
						loading={isDeletingAgreement}
					>
						{t("REMOVE")}
					</Button>
				</Flex>
			</Flex>
		</Modal>
	);
};
